<template>
    <div v-if="failure" class="route-load-feedback" role="alert">
        <span>{{ failure.message }}</span>
        <a :href="reloadPath" class="route-load-retry">刷新并打开</a>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { routeLoadFailure, routeReloadPath } from '../utils/routeLoadRecovery'

export default defineComponent({
    name: 'RouteLoadFeedback',
    setup() {
        const reloadPath = computed(() => routeLoadFailure.value ? routeReloadPath(routeLoadFailure.value.fullPath) : '')
        return { failure: routeLoadFailure, reloadPath }
    }
})
</script>

<style scoped>
.route-load-feedback {
    position: fixed;
    z-index: 2200;
    top: calc(var(--app-safe-top, 0px) + 12px);
    left: calc(var(--app-safe-left, 0px) + 12px);
    right: calc(var(--app-safe-right, 0px) + 12px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    max-width: 600px;
    margin: 0 auto;
    padding: 12px 16px;
    color: #713e22;
    background: #fff7ed;
    border: 1px solid #efc7a0;
    border-radius: 10px;
    box-shadow: 0 4px 20px #00000014;
    font-size: 14px;
    line-height: 1.6;
}
.route-load-feedback span { min-width: 0; }
.route-load-retry {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    padding: 0 12px;
    color: #713e22;
    background: white;
    border: 1px solid #dba777;
    border-radius: 7px;
}
.route-load-retry:focus-visible { outline: 2px solid #789ade; outline-offset: 3px; }
@media (max-width: 380px) {
    .route-load-feedback { align-items: flex-start; padding: 10px; gap: 8px; }
    .route-load-retry { padding: 0 8px; }
}
</style>
